import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./LanguageSelectorListItem.module.scss";
export const LanguageSelectorListItem = ({ language, selectedLanguageCode, onSelectLanguage, }) => {
    const isItemActive = language.associatedCookieValue === selectedLanguageCode;
    const handleSelectLanguage = () => {
        onSelectLanguage(language);
    };
    return (_jsx("li", { className: classNames(styles.listItem, { [styles.listItemActive]: isItemActive }), children: _jsx("button", { type: "button", "data-testid": "languageSelectorLangBtn", className: classNames(styles.listItemBtn, {
                [styles.listItemBtnActive]: isItemActive,
            }), onClick: handleSelectLanguage, children: language.languageDisplayName }) }));
};
//# sourceMappingURL=LanguageSelectorListItem.js.map